import { ResourceHeaders } from '..'
import {
  IdHeader,
  VehicleHeader,
  InspectionProgressHeader,
  InspectionQualificationHeader,
  InspectionStatusHeader,
  WhatsappHeader,
  AddressHeader,
  BusinessHeader,
  DateHeader, InspectionSummary,
} from '../../headers'
import { Helpers } from '@/views/datatables/resources/helpers'
import { Person } from '@/entities/persons'

export const headers: ResourceHeaders = [
  { ...IdHeader, text: 'Nº', value: '@' },
  { ...VehicleHeader, text: 'Vehiculo', value: 'appraisal.deal.auto' },
  { ...DateHeader, text: 'Fecha Agendada', value: 'scheduled' },
  { ...DateHeader, text: 'Fecha Inicio', value: 'dateFormatted' },
  { ...AddressHeader, text: 'Ubicación', value: 'address' },
  { ...BusinessHeader, text: 'Negocio ', value: 'appraisal.deal.lead.pipeline' },
  { ...InspectionStatusHeader, text: 'Estado', value: '@' },
  { ...InspectionProgressHeader, text: 'Progreso', value: '@' },
  {
    ...WhatsappHeader,
    text: 'Ejecutivo',
    value: 'executive',
    options: {
      action: {
        color: 'green',
        icon: 'mdi-whatsapp',
        only: true,
        trigger: (item: Person) => Helpers.contact(item, 'Supervisor'),
      },
      disabledMissingProperty: ['phone'],
    },
  },
  {
    ...WhatsappHeader,
    text: 'Inspector',
    value: 'inspector',
    options: {
      action: {
        color: 'primary',
        icon: 'mdi-whatsapp',
        only: true,
        trigger: (item: Person) => Helpers.contact(item, 'Supervisor'),
      },
    },
  },
  {
    ...InspectionSummary,
    text: 'Reporte',
    value: '@',
    options: {
      tooltip: 'Reporte',
      disabled: true,
      action: {
        close: true,
        color: 'purple',
        icon: 'mdi-clipboard-text-search-outline',
        only: true,
      },
    },
  },
  { ...InspectionQualificationHeader, text: 'Calificación', value: 'qualification' },
]

export default function (): ResourceHeaders {
  return headers
}
